import React from 'react';
import { Body, Card } from '@walmart-web/livingdesign-components';

import styles from './styles.module.css';

type Props = {
  title: string;
  icon: string;
  onClick: () => unknown;
};

const ResourcePanelItem: React.FC<Props> = ({ title, icon: Icon, onClick }) => {
  return (
    <Card className={styles.resourceItem} onClick={onClick}>
      <img className={styles.itemImage} src={Icon} />
      <Body size="medium" weight={700}>
        {title}
      </Body>
    </Card>
  );
};

export default ResourcePanelItem;
